import { X } from 'lucide-react'
import { useTranslation } from '@/i18n'
import { IntuiButton } from '@/components/intueri/IntuiButton'
import { AKEERA_AVATAR_SRC } from './constants'

/** Card header: Akeera avatar + name + subtitle + close. */
const HelpAgentHeader = ({ onClose }: { onClose: () => void }) => {
  const { t } = useTranslation('help_agent')
  return (
    <div className="flex items-center gap-3 border-b border-gray-100 px-4 py-3 dark:border-dark-border">
      <img
        src={AKEERA_AVATAR_SRC}
        alt={t('header.name')}
        className="size-10 shrink-0 rounded-full object-cover"
      />
      <div className="min-w-0 flex-1">
        <div className="truncate text-sm font-semibold text-gray-900 dark:text-dark-text">
          {t('header.name')}
        </div>
        <div className="truncate text-xs text-muted-foreground">{t('header.subtitle')}</div>
      </div>
      <IntuiButton
        variant="ghost"
        size="icon-sm"
        aria-label={t('header.close')}
        onClick={onClose}
        className="shrink-0 rounded-full text-muted-foreground"
      >
        <X />
      </IntuiButton>
    </div>
  )
}

export default HelpAgentHeader
